import { render, staticRenderFns } from "./MusicUpload.vue?vue&type=template&id=82b9c482&scoped=true"
import script from "./MusicUpload.vue?vue&type=script&lang=js"
export * from "./MusicUpload.vue?vue&type=script&lang=js"
import style0 from "./MusicUpload.vue?vue&type=style&index=0&id=82b9c482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b9c482",
  null
  
)

export default component.exports